import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export default class Slider {
  constructor(els, args = {}, autoScroll = false) {
    this.els = document.querySelectorAll(els);
    this.args = { rewind: true, mediaQuery: 'max', ...args };
    this.autoScroll = autoScroll ? { AutoScroll } : false;
    this.sliders = [];
  }

  init() {
    //console.log(this.els);
    if (!this.els.length) {
      return;
    }

    [...this.els].forEach((el) => {
      //console.log(el);
      const slideRoot = el.querySelector('.splide');
      const splide = new Splide(slideRoot, this.args);

      if (this.autoScroll) {
        splide.mount({
          AutoScroll,
        });
      } else {
        splide.mount();
      }

      this.sliders.push(splide);
    });
  }
}
